(function () {
var $f5b7a22d3d3cc261$var$header = {
    init: function() {
        this.initToggle();
        this.initDrilldown();
        this.initMegaMenu();
        this.initScrollBehavior();
    },
    initScrollBehavior: function() {
        var el = document.querySelector('header');
        if (!el) return;
        var lastY = window.scrollY;
        var ticking = false;
        window.addEventListener('scroll', function() {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(function() {
                var _document_getElementById;
                var currentY = window.scrollY;
                var isNavOpen = document.body.classList.contains('nav--toggled');
                var isMegaOpen = (_document_getElementById = document.getElementById('mega-menu')) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.classList.contains('is-open');
                if (!isNavOpen && !isMegaOpen) {
                    if (currentY > lastY && currentY > el.offsetHeight) el.classList.add('header--hidden');
                    else el.classList.remove('header--hidden');
                }
                lastY = currentY;
                ticking = false;
            });
        }, {
            passive: true
        });
    },
    initToggle: function() {
        var _this = this;
        var navToggle = document.querySelector('.nav-toggle');
        var navWrapper = document.getElementById('nav-wrapper');
        if (!navToggle || !navWrapper) return;
        navToggle.addEventListener('click', function() {
            var isExpanded = navToggle.getAttribute('aria-expanded') === 'true';
            navToggle.setAttribute('aria-expanded', String(!isExpanded));
            navToggle.setAttribute('aria-label', isExpanded ? 'Open menu' : 'Close menu');
            navWrapper.classList.toggle('is-open', !isExpanded);
            if (isExpanded) _this.resetPanels();
        });
    },
    initDrilldown: function() {
        var _this = this;
        var panelsEl = document.getElementById('nav-panels');
        if (!panelsEl) return;
        var stack = [
            'root'
        ];
        this._resetDrilldownStack = function() {
            stack.length = 0;
            stack.push('root');
        };
        panelsEl.addEventListener('click', function(e) {
            var trigger = e.target.closest('[data-open-panel]');
            if (trigger) {
                var toId = trigger.dataset.openPanel;
                _this.showPanel(panelsEl, stack[stack.length - 1], toId, 'forward');
                stack.push(toId);
                return;
            }
            var backBtn = e.target.closest('[data-back]');
            if (backBtn && stack.length > 1) {
                var fromId = stack.pop();
                _this.showPanel(panelsEl, fromId, stack[stack.length - 1], 'back');
            }
        });
    },
    showPanel: function(panelsEl, fromId, toId, direction) {
        var fromPanel = panelsEl.querySelector('[data-panel="'.concat(fromId, '"]'));
        var toPanel = panelsEl.querySelector('[data-panel="'.concat(toId, '"]'));
        if (!fromPanel || !toPanel) return;
        if (direction === 'forward') {
            fromPanel.removeAttribute('data-active');
            fromPanel.setAttribute('data-behind', '');
            toPanel.setAttribute('data-active', '');
        } else {
            fromPanel.removeAttribute('data-active');
            toPanel.removeAttribute('data-behind');
            toPanel.setAttribute('data-active', '');
        }
    },
    resetPanels: function() {
        var panelsEl = document.getElementById('nav-panels');
        if (!panelsEl) return;
        panelsEl.querySelectorAll('[data-panel]').forEach(function(panel) {
            panel.removeAttribute('data-active');
            panel.removeAttribute('data-behind');
        });
        var root = panelsEl.querySelector('[data-panel="root"]');
        if (root) root.setAttribute('data-active', '');
        if (this._resetDrilldownStack) this._resetDrilldownStack();
    },
    initMegaMenu: function() {
        var _this = this;
        var megaMenu = document.getElementById('mega-menu');
        if (!megaMenu) return;
        // trigger click — open matching panel, or close if already open
        document.querySelectorAll('[data-mega-trigger]').forEach(function(trigger) {
            trigger.addEventListener('click', function(e) {
                e.stopPropagation();
                var id = trigger.dataset.megaTrigger;
                var isExpanded = trigger.getAttribute('aria-expanded') === 'true';
                _this.closeMegaMenu();
                if (!isExpanded) {
                    trigger.setAttribute('aria-expanded', 'true');
                    megaMenu.classList.add('is-open');
                    megaMenu.setAttribute('aria-hidden', 'false');
                    var panel = megaMenu.querySelector('[data-mega-panel="'.concat(id, '"]'));
                    if (panel) panel.classList.add('is-active');
                }
            });
        });
        // primary / secondary item click → show next column
        megaMenu.addEventListener('click', function(e) {
            var primaryTrigger = e.target.closest('[data-mega-primary]');
            if (primaryTrigger) {
                var panel = primaryTrigger.closest('[data-mega-panel]');
                if (panel) _this.activatePrimaryItem(panel, primaryTrigger.dataset.megaPrimary);
                return;
            }
            var secondaryTrigger = e.target.closest('[data-mega-secondary-trigger]');
            if (secondaryTrigger) {
                var panel1 = secondaryTrigger.closest('[data-mega-panel]');
                if (panel1) _this.activateSecondaryItem(panel1, secondaryTrigger.dataset.megaSecondaryTrigger);
            }
        });
        // close on outside click
        document.addEventListener('click', function(e) {
            if (megaMenu.classList.contains('is-open') && !e.target.closest('[data-mega-trigger]') && !e.target.closest('#mega-menu')) _this.closeMegaMenu();
        });
    },
    activatePrimaryItem: function(panel, id) {
        // deactivate all primary items
        panel.querySelectorAll('[data-mega-primary]').forEach(function(btn) {
            btn.closest('.mega-menu__item').classList.remove('mega-menu__item--active');
            btn.setAttribute('aria-expanded', 'false');
        });
        // hide all secondary lists + reset tertiary
        panel.querySelectorAll('[data-mega-secondary]').forEach(function(list) {
            list.classList.remove('is-active');
        });
        panel.querySelectorAll('[data-mega-secondary-trigger]').forEach(function(btn) {
            btn.closest('.mega-menu__item').classList.remove('mega-menu__item--active');
            btn.setAttribute('aria-expanded', 'false');
        });
        panel.querySelectorAll('[data-mega-tertiary]').forEach(function(list) {
            list.classList.remove('is-active');
        });
        // activate matching primary item
        var activeBtn = panel.querySelector('[data-mega-primary="'.concat(id, '"]'));
        if (activeBtn) {
            activeBtn.closest('.mega-menu__item').classList.add('mega-menu__item--active');
            activeBtn.setAttribute('aria-expanded', 'true');
        }
        // show matching secondary list
        var secondaryList = panel.querySelector('[data-mega-secondary="'.concat(id, '"]'));
        if (secondaryList) secondaryList.classList.add('is-active');
    },
    activateSecondaryItem: function(panel, id) {
        panel.querySelectorAll('[data-mega-secondary-trigger]').forEach(function(btn) {
            btn.closest('.mega-menu__item').classList.remove('mega-menu__item--active');
            btn.setAttribute('aria-expanded', 'false');
        });
        panel.querySelectorAll('[data-mega-tertiary]').forEach(function(list) {
            list.classList.remove('is-active');
        });
        var activeBtn = panel.querySelector('[data-mega-secondary-trigger="'.concat(id, '"]'));
        if (activeBtn) {
            activeBtn.closest('.mega-menu__item').classList.add('mega-menu__item--active');
            activeBtn.setAttribute('aria-expanded', 'true');
        }
        var tertiaryList = panel.querySelector('[data-mega-tertiary="'.concat(id, '"]'));
        if (tertiaryList) tertiaryList.classList.add('is-active');
    },
    closeMegaMenu: function() {
        var megaMenu = document.getElementById('mega-menu');
        if (!megaMenu) return;
        megaMenu.classList.remove('is-open');
        megaMenu.setAttribute('aria-hidden', 'true');
        document.querySelectorAll('[data-mega-trigger]').forEach(function(t) {
            t.setAttribute('aria-expanded', 'false');
        });
        megaMenu.querySelectorAll('[data-mega-panel]').forEach(function(panel) {
            panel.classList.remove('is-active');
        });
        megaMenu.querySelectorAll('[data-mega-secondary],[data-mega-tertiary]').forEach(function(list) {
            list.classList.remove('is-active');
        });
        megaMenu.querySelectorAll('[data-mega-primary],[data-mega-secondary-trigger]').forEach(function(btn) {
            btn.closest('.mega-menu__item').classList.remove('mega-menu__item--active');
            btn.setAttribute('aria-expanded', 'false');
        });
    }
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function() {
    return $f5b7a22d3d3cc261$var$header.init();
});
else $f5b7a22d3d3cc261$var$header.init();

})();
//# sourceMappingURL=script.js.map
